/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Current status of the payment receipt
 * @export
 * @enum {string}
 */
export enum TeamPaymentReceiptStatus {
    Uploaded = 'UPLOADED',
    Approved = 'APPROVED',
    Rejected = 'REJECTED'
}


export function TeamPaymentReceiptStatusFromJSON(json: any): TeamPaymentReceiptStatus {
    return TeamPaymentReceiptStatusFromJSONTyped(json, false);
}

export function TeamPaymentReceiptStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamPaymentReceiptStatus {
    return json as TeamPaymentReceiptStatus;
}

export function TeamPaymentReceiptStatusToJSON(value?: TeamPaymentReceiptStatus | null): any {
    return value as any;
}

